module.exports = __webpack_public_path__ + "static/media/Stock 4.56c8cb6c.svg";